import React, { useState } from 'react';
import "./Inputs.scss";
import { TextField } from '@mui/material';
import { useController, UseFormRegisterReturn } from 'react-hook-form';
import Editor, { ContentEditableEvent } from 'react-simple-wysiwyg';

interface IStringInput extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    label: any;
    register: UseFormRegisterReturn;
    error?: string;
}

function StringInput({ label, register, error, ...props }: IStringInput) {
    console.log("register.required ", register.required, register.name)
    return (
        <div className='PasswordInput' style={{minHeight: "21px", ...props.style}}>
            <label htmlFor="1" className='PasswordInputLabel'>{label}{register.required && "*"}</label>
            <input id="1" type="text" className='PasswordInputContent' {...props} {...register} />
            <p className='text-12 red' style={{fontStyle: "italic"}}>{!!error && error}</p>
        </div>
    )
}
export function NumberInput({ label, register, ...props }: IStringInput) {
    const onKeyPress=(event) => {
        if (!/[0-9]/.test(event.key)) {
          event.preventDefault();
        }
      }
    return (
        <div className='PasswordInput' style={props.style}>
            <label htmlFor="1" className='PasswordInputLabel'>{label}</label>
            <input id="1" onKeyPress={onKeyPress} type="number" className='PasswordInputContent' {...props} {...register} />
        </div>
    )
}
export function TextInput({ label, register, error, ...props }: IStringInput) {
    return (
        // @ts-ignore
        <TextField
            id="outlined-multiline-static"
            label={label}
            multiline
            rows={4}
            {...register}
            {...props}
            helperText={error}
            InputLabelProps={{ shrink: true }}
        />
    )
}

export function RichTextInput({ label, name, control, error, ...props }: any) {
    const {
        field,
        fieldState: { invalid, isTouched, isDirty },
        formState: { touchedFields, dirtyFields }
    } = useController({name, control});
    return (
        <div className='RichTextInput' style={{minHeight: "21px", ...props.style}}>
            <label htmlFor="1" className='PasswordInputLabel'>{label}</label>
            <Editor 
                containerProps={{
                    style: {"width": "100%", "maxWidth": "100%"}
                }}
                value={field.value}
                onChange={field.onChange}
                {...props}
            />
            <p className='text-12 red' style={{fontStyle: "italic"}}>{!!error && error}</p>
        </div>
    )
}

export default StringInput;